import { Filter } from "../../models/filter";

export let ACTUAL_FILTER: Filter;
export let AUTOCOMPLETE_FIELD: string;
export let CALL_GET_OFFERS: string;
export let CALL_GET_OFFERS_WITH_FILTERS: string;
export let CALL_GET_SEO_PHRASE: string;
export let IS_USER_LOGGED: boolean;
export let POST_USER_ACT_CAND_URL: string;
export let CALL_GET_FILTERS: string;
export let BASE_URL: string;
export let JOB_TEXT: string;
export let TOWN_TEXT: string;
export let FUNCTION_TEXT: string;
export let SEARCHER_TEXT: string;

export let CREATE_ALERT_TEXT: string;
export let MAX_ALERTS_TEXT: string;
export let ALERT_CREATED_ONE: string;
export let ALERT_CREATED_MORE: string;
export let ALERT_ALREADY_CREATED: string;
export let ALERT_MAX_ALERTS: string;
export let ALERTS_NUMBER: string;

export let CURRENT_REQUESTS: { requestsNumber: number } = { requestsNumber: 0 };
export let LOGIN_URL: string;
export let LOGIN_BLOCK_MAX_TRIES: number;
export let LOGIN_BLOCK_MINUTES: number;
export let LOGIN_BLOCK_TRIES_COOKIE_NAME: string;
export let LOGIN_BLOCK_MINUTES_COOKIE_NAME: string;

$(() => {
  ACTUAL_FILTER = JSON.parse(
    atob($("#offersSettings").attr("data-ACTUAL_FILTER")!)
  );
  AUTOCOMPLETE_FIELD = JSON.parse(
    atob($("#offersSettings").attr("data-AUTOCOMPLETE_FIELD")!)
  );
  CALL_GET_OFFERS = $("#offersSettings").attr("data-CALL_GET_OFFERS")!;
  CALL_GET_OFFERS_WITH_FILTERS = $("#offersSettings").attr(
    "data-CALL_GET_OFFERS_WITH_FILTERS"
  )!;
  CALL_GET_SEO_PHRASE = $("#offersSettings").attr("data-CALL_GET_SEO_PHRASE")!;
  IS_USER_LOGGED = $("#offersSettings").attr("data-IS_USER_LOGGED") === "true";
  POST_USER_ACT_CAND_URL = $("#offersSettings").attr(
    "data-POST_USER_ACT_CAND_URL"
  )!;
  CALL_GET_FILTERS = $("#offersSettings").attr("data-CALL_GET_FILTERS")!;
  BASE_URL = $("#offersSettings").attr("data-BASE_URL")!;
  JOB_TEXT = $("#offersSettings").attr("data-JOB_URL")!;
  TOWN_TEXT = $("#offersSettings").attr("data-TOWN_URL")!;
  FUNCTION_TEXT = $("#offersSettings").attr("data-FUNCTION_URL")!;
  SEARCHER_TEXT = $("#offersSettings").attr("data-SEARCHER_URL")!;
  CREATE_ALERT_TEXT = $("#offersSettings").attr("data-CREATE_ALERT_TEXT")!;
  MAX_ALERTS_TEXT = $("#offersSettings").attr("data-MAX_ALERTS_TEXT")!;
  ALERT_CREATED_ONE = $("#offersSettings").attr("data-ALERT_CREATED_ONE")!;
  ALERT_CREATED_MORE = $("#offersSettings").attr("data-ALERT_CREATED_MORE")!;
  ALERT_ALREADY_CREATED = $("#offersSettings").attr("data-ALERT_ALREADY_CREATED")!;
  ALERT_MAX_ALERTS = $("#offersSettings").attr("data-ALERT_MAX_ALERTS")!;
  ALERTS_NUMBER = $("#offersSettings").attr("data-ALERTS_NUMBER")!;

  LOGIN_URL = $("#offersSettings").attr("data-LOGIN_URL")!;
  LOGIN_BLOCK_MAX_TRIES = 4;
  LOGIN_BLOCK_MINUTES = 10;
  LOGIN_BLOCK_TRIES_COOKIE_NAME = "ett-password-block";
  LOGIN_BLOCK_MINUTES_COOKIE_NAME = "ett-password-block-time";
});
